// extracted by mini-css-extract-plugin
module.exports = {"abilityScores":"MonsterDescription_abilityScores_HJF3A"};